export default __webpack_public_path__ + "static/media/ApprovedPickupIcon.ea9dc2cc.svg";